export default __webpack_public_path__ + "static/media/colored-orders.5b465665.svg";